.search-field {
    font-weight: normal;
}
